import React, { useEffect, useState } from 'react';
import _ from 'lodash';

export interface ListItem {
    hidden?: boolean;
    [key: string]: any;
}

interface SearchTextComponentProps<T extends ListItem> {
    listData: T[];
    callback: (updatedList: T[]) => void;
    updateRefresh: () => void;
    refresh: boolean
}

const SearchTextComponent = <T extends ListItem>({ listData, callback, refresh, updateRefresh }: SearchTextComponentProps<T>) => {
    const [filterText, setFilterText] = useState<string>('');

    useEffect(() => {
        if (refresh) {
            updateRefresh();
            setFilterText('');            
        }
    }, [refresh, updateRefresh]);
    
    const filter = (coll: T[], filterVal: string, maxDepth = 3) => {
        _.forEach(coll, item => {
            item.hidden = false;
        });
        if (filterVal.length < 1) {
            callback(coll);
            return;
        }
        const rejected = _.reject(coll, item => traverse(item, filterVal, 1, maxDepth));
        _.forEach(rejected, item => {
            item.hidden = true;
        });
        callback(coll);
    };

    const traverse = (item: ListItem, filterVal: string, depth: number, maxDepth: number): boolean => {
        if (depth >= maxDepth) return false;
        for (const value of Object.values(item)) {
            let valStr: string | undefined;

            if (_.isNumber(value)) {
                valStr = value.toString();
            } else if (_.isString(value)) {
                valStr = value;
            }

            if (valStr && valStr.includes(filterVal)) {
                return true;
            } else if (_.isArray(value)) {
                if (value.some(v => traverse(v as ListItem, filterVal, depth + 1, maxDepth))) {
                    return true;
                }
            } else if (_.isPlainObject(value)) {
                if (traverse(value as ListItem, filterVal, depth + 1, maxDepth)) {
                    return true;
                }
            }
        }

        return false;
    };

    return (
        <input
            className="filter"
            type="text"
            placeholder="Type here to filter rows..."
            value={filterText}
            onChange={e => {
                setFilterText(e.target.value);
                filter(listData, e.target.value, 3);
            }}
        />
    );
};

export default SearchTextComponent;